import { Component, OnDestroy, OnInit, signal, inject } from '@angular/core';
import {
  ICreateTratamientoEvento,
  IEventoGenerico,
  IFilter,
  IModeloDispositivo,
  IPopulate,
  IQueryParam,
} from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import {
  IColumnas,
  IRowIcon,
} from '../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { TratamientoGenericoComponent } from '../tratar-evento-generico/tratamiento-generico/tratamiento-generico.component';
import { TratamientoEventosService } from '../../../../auxiliares/servicios/http/tratamientos-eventos.service';
import { EventosGenericosHelperService } from '../helper';
import { ModeloDispositivoSelectorCacheService } from '../../../../componentes/selectores/modelo-dispositivo-selector/modelo-dispositivo-selector-cache.service';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';

@Component({
  selector: 'app-eventos-genericos-espera',
  templateUrl: './eventos-genericos-espera.component.html',
  styleUrl: './eventos-genericos-espera.component.scss',
  standalone: false,
})
export class EventosGenericosEsperaComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2Service = inject(Lista2Service);
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private dialogService = inject(DialogService);
  private service = inject(TratamientoEventosService);
  private eventosHelper = inject(EventosGenericosHelperService);
  private modeloCache = inject(ModeloDispositivoSelectorCacheService);

  public listando = false;
  public loading = signal(false);
  //// Tabla nueva
  public name = EventosGenericosEsperaComponent.name;
  public eventosEspera: IEventoGenerico[] = [];
  public eventosEspera$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IEventoGenerico>[];
  // Filtros Tabla
  public search: IRegExpSearch = {
    fields: ['valores.titulo', 'valores.mensaje'],
  };
  private entidad: IFiltroTabla = {
    filter: {
      field: 'idEntidad',
    },
    label: 'Entidad',
    tipo: 'entidad-eventos-selector',
  };
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  private fecha: IFiltroTabla = {
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Fecha',
    tipo: 'dateRange',
  };
  public filtros: IFiltroTabla[] = [
    this.fecha,
    this.entidad,
    this.cliente,
    this.ancestro,
  ];

  //////////////////////////////////////////////////////////
  // FILTROS

  public populate: IPopulate[] = [
    {
      path: 'alarma',
      populate: [
        {
          path: 'domicilio',
          select: 'direccion',
        },
        {
          path: 'modelo',
          select: 'marca modelo',
        },
        {
          path: 'idServiciosContratados',
        },
      ],
    },
    {
      path: 'activo',
      select: 'identificacion',
    },
    {
      path: 'tracker',
      select: 'identificacion',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'luminaria',
      select: 'identificacion',
    },
    {
      path: 'gateway',
      select: 'nombre nombreChirpstack',
    },
    {
      path: 'botonBluetooth',
      select: 'mac',
    },
    {
      path: 'sirena',
      select: 'chipId',
    },
  ];
  private filter: IFilter<IEventoGenerico> = {
    estado: 'En Espera',
    filtrador: 'Evento',
  };
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    filter: JSON.stringify(this.filter),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    executionStats: true,
    // includeChildren: true, // Generic events might not have children logic yet?
    // childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    this.listando = true;
    this.eventosEspera$?.unsubscribe();
    // Using eventosGenericos instead of eventos
    this.eventosEspera$ = this.lista2Service
      .eventosGenericos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.eventosEspera = data.datos;
        this.listando = false;
      });
  }
  // Acciones
  public async detalles(evento: IEventoGenerico) {
    // Adapted from EventosGenericosVivosComponent
    if (evento?.alarma?._id) {
      this.navigator.navigate([
        `main/alarmas/alarmasDomiciliarias/detallesAlarma/${evento.alarma._id}`,
      ]);
      return;
    }
    if (evento?.luminaria?._id) {
      this.navigator.navigate([
        `main/luminarias/luminarias/detalles/${evento.luminaria._id}`,
      ]);
      return;
    }

    if (evento?.gateway?._id) {
      this.navigator.navigate([
        `main/administracion/gateways/detalles/${evento.gateway._id}`,
      ]);
      return;
    }
    if (evento?.activo?._id) {
      if (evento.activo.vehiculo) {
        this.navigator.navigate([
          `main/vehiculos/vehiculos/detalles/${evento.activo._id}`,
        ]);
        return;
      } else {
        this.navigator.navigate([
          `main/activos/activos/detalles/${evento.activo._id}`,
        ]);
        return;
      }
    }
    if (evento.sirena?._id) {
      this.navigator.navigate([
        `main/sirenas/sirenas/detalles/${evento.sirena._id}`,
      ]);
      return;
    }
  }

  public async liberar(evento: IEventoGenerico) {
    const res = await this.dialogService.confirm(
      'Liberar evento',
      '¿Querés liberar el evento?',
    );
    if (!res) return;
    const tratamiento: ICreateTratamientoEvento = {
      idsEventos: [evento._id],
      estado: 'Liberada',
    };
    try {
      this.loading.set(true);
      await this.service.createGenerico(tratamiento);
      this.helper.notifSuccess('Evento liberado');
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    } finally {
      this.loading.set(false);
    }
  }

  public async tratar(evento: IEventoGenerico) {
    const config: MatDialogConfig = {
      data: { idEvento: evento._id },
      hasBackdrop: false,
      minWidth: '800px',
      maxWidth: '1000px',
      closeOnNavigation: false,
      disableClose: true,
    };

    const dialogRef = this.dialog.open(TratamientoGenericoComponent, config);
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      // Recargar listado después de tratar
      this.listar();
    }
  }
  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IEventoGenerico>[] = [
      // Fecha
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      // Categoría: badge del color de la categoría con el nombre adentro
      {
        header: {
          label: 'Categoría',
        },
        row: {
          html: (dato) => this.eventosHelper.categoriaHtml(dato),
          noData: 'Sin categoría',
        },
      },
      // Nombre evento
      {
        header: {
          label: 'Evento',
        },
        row: {
          parse(dato) {
            return dato.valores?.titulo;
          },
          noData: 'Sin título',
        },
      },
      // Detalles
      {
        header: {
          label: 'Detalles',
        },
        row: {
          parse(dato) {
            return dato.valores?.['mensaje'];
          },
          noData: 'Sin detalles',
        },
      },
      // Activo / Alarma / Entidad
      {
        header: {
          label: 'Entidad',
        },
        row: {
          html: (dato) => this.eventosHelper.obtenerEntidad(dato),
          noData: 'Sin asignar',
        },
      },
      // Dispositivo (Tracker, Communicator, etc.)
      {
        header: {
          label: 'Dispositivo',
        },
        row: {
          parse: (dato) => {
            if (dato.tracker) {
              return dato.tracker?.identificacion || '';
            }
            if (dato.gateway) {
              return (
                dato.gateway?.nombre || dato.gateway?.nombreChirpstack || ''
              );
            }
            if (dato.luminaria) {
              return dato.luminaria?.identificacion || '';
            }
            if (dato.alarma) {
              let text = '';
              const marcasModelos = (dato.alarma.comunicadores ?? [])
                .map((c) =>
                  this.modeloCache.getModeloPorIdSync(c.idComunicador),
                )
                .filter((m): m is IModeloDispositivo => !!m)
                .map((m) => `${m.marca} ${m.modelo}`);
              if (marcasModelos.length) {
                text = marcasModelos.join(', ');
              }
              const alarma = dato.alarma.modelo;
              if (alarma) {
                text += ` - ${alarma.marca} ${alarma.modelo}`;
              }
              if (text.length >= 50) {
                text = text.slice(0, 50);
                text += '…';
              }
              return text;
            }
            if (dato.sirena) {
              return dato.sirena?.chipId || '';
            }
            return '';
          },
          noData: 'Sin identificación',
        },
      },
      // Notificar (Assuming Generic Events don't have this or it's different, commenting out for now unless I find it)
      /*
      {
        header: {
          label: 'Requiere Atención',
          sortable: true,
          sort: 'notificar',
        },
        row: {
          icono: (dato) => {
            const iconCheck: IRowIcon = {
              icon: 'check',
              color: 'green',
              tipo: 'material',
            };
            const iconClose: IRowIcon = {
              icon: 'close',
              color: 'red',
              tipo: 'material',
            };
            return dato.notificar ? iconCheck : iconClose;
          },
        },
      },
      */
      // Aplazado hasta (Assuming Generic Events don't have this)
      /*
      {
        header: {
          label: 'Aplazado hasta',
        },
        row: {
          field: 'posponerHasta',
          pipe: {
            pipe: DatePipe,
            args: ['dd/MM/yyyy HH:mm'],
          },
        },
      },
      */

      //Tiempo de repsuesta (Assuming Generic Events don't have this)
      /*
      {
        header: {
          label: 'Tiempo de respuesta (min)',
          sortable: true,
          sort: 'tiempoRespuesta',
        },
        row: {
          parse(dato) {
            if (dato.tiempoRespuesta) {
              // Redondeo al entero más cercano
              return `${Math.round(dato.tiempoRespuesta / 60)}`;
            }
            return '';
          },
          noData: 'Sin información',
        },
      },
      */
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          },
        });
      }
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          // {
          //   tipo: 'material',
          //   color: 'primary',
          //   icon: 'visibility',
          //   tooltip: 'Detalles',
          //   click: (dato) => this.detalles(dato),
          // },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'lock_open',
            tooltip: 'Liberar',
            click: (dato) => this.liberar(dato),
            disabled: () => this.loading(),
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'troubleshoot',
            tooltip: 'Atender',
            click: (dato) => this.tratar(dato),
            disabled: () => this.loading(),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    // Warm-up: fila "Dispositivo" resuelve marca/modelo de comunicadores[]
    // por id de forma síncrona (getModeloPorIdSync) — necesita el cache tibio.
    this.modeloCache.getModelos().subscribe();
    this.setColumnas();
    await Promise.all([this.listar()]);
  }

  async ngOnDestroy() {
    this.eventosEspera$?.unsubscribe();
  }
}
